export * from './pagecontent.model';
export * from './login.model';
export * from './tenant.model';
export * from './userstate.model';
export * from './juris.model';
export * from './screens.model';
export * from './namedtl.model';
export * from './nameaddress.model';
export * from './profileinfo.model';
export * from './phonenumber.model';
export * from './address.model';
export * from './addressinfo.model';
export * from './coded.model';
export * from './codevalue.model';
export * from './codetype.model';
export * from './config.model';
export * from './password.model';
export * from './txtattach.model';
export * from './paraminfo.model';
export * from './citnews.model';
export * from './codedinfo.model';
export * from './cspreport.model';


// WEBPACK FOOTER //
// D:/NewPhoenixScrum/PhoenixScrum/Main/CitizenSevicesEx/CSClient/CSClient/client/app/core/index.model.ts